import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-hidden": "true",
  class: "cursor-spotlight"
}
const _hoisted_2 = {
  ref: "glowEl",
  class: "cursor-spotlight__glow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, null, 512)
      ]))
    : _createCommentVNode("", true)
}